module.exports = __webpack_public_path__ + "static/assets/3bbdee44cc5d9caaf03d5dc5949a228d.svg";